const LANGUAGE_KEY = 'superjobs_language'

const storage = window.localStorage

export const storeLanguage = (language) => storage.setItem(LANGUAGE_KEY, language)

export const getLanguage = () => storage.getItem(LANGUAGE_KEY)


